const ChartPie = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.25 19.25L8.75 15.75L12.25 12.25M12.25 12.25V2.25M12.25 12.25H22.25"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.25 22.25C17.7728 22.25 22.25 17.7728 22.25 12.25C22.25 6.72715 17.7728 2.25 12.25 2.25C6.72715 2.25 2.25 6.72715 2.25 12.25C2.25 17.7728 6.72715 22.25 12.25 22.25Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default ChartPie;
